<template>
  <div>
    <div class="right-title">
      <span>创建帐号</span>
    </div>
    <div class="content-box">
      <div class="gw-info-box">
        <el-form ref="form" :model="form" :rules="rules" label-width="120px">
          <el-form-item label="机构名称：" prop="account">
            <el-input v-model="form.account" placeholder="请输入帐号"></el-input>
          </el-form-item>
          <el-form-item label="密码：" prop="pass">
            <el-input type="password" placeholder="请输入密码" v-model="form.pass" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="电话：" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入电话号"></el-input>
          </el-form-item>
          <el-form-item label="联系人：" prop="name">
            <el-input v-model="form.name" placeholder="请输入联系人名字"></el-input>
          </el-form-item>
          <el-form-item style="margin-top: 130px;">
            <el-button type="primary" class="submit" @click="onSubmit()">创建</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <footerBox class="footer"/>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'

  export default {
    name: "jgAccountadd",
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else if (value.length < 6) {
          callback(new Error('请输入6位以上的密码'));
        } else {
          if (this.form.checkPass !== '') {
            this.$refs.form.validateField('checkPass');
          }
          callback();
        }
      };
      var checkPhone = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('手机号不能为空'));
        } else {
          const reg = /^1[0-9]\d{9}$/
          console.log(reg.test(value));
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error('请输入正确的手机号'));
          }
        }
      };
      return {
        Type: 0,
        form: {
          account: '',     //  帐号
          pass: '',
          name: '',
          phone: ''

        },
        rules: {
          account: [
            {required: true, message: '请输入机构名称', trigger: 'blur'},
            {min: 4, message: '长度需四位字符以上', trigger: 'blur'}
          ],
          pass: [
            {required: true, validator: validatePass, trigger: 'blur'}
          ],
          phone: [
            {required: true, validator: checkPhone, trigger: 'blur'}
          ],
          name: [
            {required: true, message: '请输入联系人名字', trigger: 'blur'}
          ],
        }
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      this.$emit('setType', 4);
    },
    methods: {
      onSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            const loading = this.$loading({
              look: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0,0,0,0.7)'
            });
            var data = {
              user_name: this.form.account,
              user_pass: this.$md5(this.form.pass),
              contact: this.form.name,
              telephone: this.form.phone,
              admin_id: this.user.id
            }
            this.$api.apiContent.jgaddorg(data)
              .then(res => {
                loading.close();
                this.$message.success(res.info)
                this.$refs.form.resetFields()
              }).catch(res => {
              loading.close();
              this.$message.error(res.info);
            })
          }
        })
      },

    },
    watch: {},
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .gw-info-box {
    width: 360px;
    padding: 50px 0;
    margin: 0 auto;

  }

  .submit {
    width: 100%;
  }
</style>